import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=4036e0fe&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=4036e0fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4036e0fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4036e0fe')) {
      api.createRecord('4036e0fe', component.options)
    } else {
      api.reload('4036e0fe', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=4036e0fe&scoped=true", function () {
      api.rerender('4036e0fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/pygame/detail.vue"
export default component.exports